import { render, staticRenderFns } from "./FillForm12.vue?vue&type=template&id=6f4f286e&scoped=true"
import script from "./FillForm12.vue?vue&type=script&lang=ts"
export * from "./FillForm12.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f286e",
  null
  
)

export default component.exports